// Genere par tools/gen-icons.mjs. Ne pas editer a la main.
import { createRemixIcon } from '../create-remix-icon.js';

export const IconPadlockSquare1 = createRemixIcon('IconPadlockSquare1', "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M12 3.5a3.25 3.25 0 0 0-3.25 3.25V10h6.5V6.75A3.25 3.25 0 0 0 12 3.5m6.75 6.5V6.75a6.75 6.75 0 0 0-13.5 0V10H2v14h20V10zm-8.25 8.5v-3h3v3zm9-6v9h-15v-9z\" clip-rule=\"evenodd\"/>");
